module.exports = __webpack_public_path__ + "static/media/fly0080.da29eae5.webp";